import React from "react";
import { Stack, Typography } from "@mui/material";
import palette from "src/theme/palette";
import { CHANNEL_META, CHANNEL_ORDER } from "./SubscriptionTab.consts";
import { LegendDot } from "./QuotaUsageSummary.styles";

// Channel legend shared by the quota-usage bar and the usage-over-time chart (Figma: dot 10px, gap 8, items 24 apart).
const ChannelLegend = ({ channelTypes = CHANNEL_ORDER, testIdPrefix = "quota-legend" }) => (
  <Stack direction="row" gap={3} alignItems="center" sx={{ px: "12px", py: "6px" }}>
    {channelTypes.map((channelType) => (
      <Stack
        key={channelType}
        direction="row"
        alignItems="center"
        gap="8px"
        data-testid={`${testIdPrefix}-${channelType}`}
      >
        <LegendDot color={CHANNEL_META[channelType].color} />
        <Typography variant="tooltip" sx={{ color: palette.text[600] }}>
          {CHANNEL_META[channelType].label}
        </Typography>
      </Stack>
    ))}
  </Stack>
);

export default ChannelLegend;
